/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actiontodayheading2Inputs */

const en_actiontodayheading2 = /** @type {(inputs: Actiontodayheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's action`)
};

const de_actiontodayheading2 = /** @type {(inputs: Actiontodayheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heutige Aktion`)
};

/**
* | output |
* | --- |
* | "Today's action" |
*
* @param {Actiontodayheading2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actiontodayheading2 = /** @type {((inputs?: Actiontodayheading2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actiontodayheading2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actiontodayheading2(inputs)
	return de_actiontodayheading2(inputs)
});
export { actiontodayheading2 as "actionTodayHeading" }